// extracted by mini-css-extract-plugin
export default {"error":"CampaignError--error--55aa8c"};